import React, { Component } from 'react';
import helper from '../services/helper';

export default class WelcomeForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            type: 'login',
            fullName: '',
            password: '',
            email: '',
            formFailed: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        let formFailed = this.props.loginAttempts < nextProps.loginAttempts;

        this.setState({
            formFailed
        });

        if(formFailed) setTimeout(() => {
            this.setState({
                formFailed: false
            });
        }, 1000);
    }

    onFormSubmit(event) {
        event.preventDefault();
    }

    onSubmit() {
        if(!this.isValid()) {
            this.setState({
                formFailed: true
            });

            setTimeout(() => {
                this.setState({
                    formFailed: false
                });
            }, 1000);
        }
        if(this.state.type === 'login') {
            this.props.onLogin(this.state.email, this.state.password);
        } else if(this.state.type === 'register') {
            this.props.onRegister(this.state.email, this.state.password, this.state.fullName);
        }
    }

    isValid() {
        // Check email.
        if(!helper.isValidEmail(this.state.email)) return false;
        // Check if password is filled in and longer than 5 characters.
        if(!this.state.password || this.state.password.length < 6) return false;
        // Check if first name is filled in.
        if(this.state.type === 'register') {
            if(!this.state.fullName) return false;
        }
        return true;
    }

    onChange(event) {
        switch(event.target.name) {
            case 'fullName':
                this.setState({
                    fullName: event.target.value
                });
                break;
            case 'email':
                this.setState({
                    email: event.target.value
                });
                break;
            case 'password':
                this.setState({
                    password: event.target.value
                });
                break;
            default:
        }
    }

    changeType(event) {
        this.setState({
            type: event.target.dataset.type
        });
    }

    render() {

        let style = {
            base: {
                borderRadius: 4,
                border: '1px solid rgba(0,0,0,0.1)',
                width: 300,
                height: 279,
                position: 'fixed',
                top: 50,
                right: 0,
                bottom: 0,
                left: 0,
                margin: 'auto',
                boxShadow: '0 0 30px rgba(0,0,0,0.1)',
                backgroundColor: '#FFFFFF',
                zIndex: 20,
            },
            nav: {

            },
            navLink: {
                cursor: 'pointer',
                float: 'left',
                display: 'block',
                textAlign: 'center',
                width: '50%',
                padding: 20,
                borderBottom: '1px solid #EEE',
                color: '#999',
                boxSizing: 'border-box',
            },
            navLinkActive: {
                cursor: 'pointer',
                float: 'left',
                display: 'block',
                textAlign: 'center',
                width: '50%',
                padding: 20,
                boxSizing: 'border-box',
                borderBottom: '1px solid #38B08C',
                color: '#38B08C',
            },
            input: {
                backgroundColor: '#F8FAFC',
                borderRadius: 4,
                width: '100%',
                border: 'none',
                outline: 'none',
                appearance: 'none',
                fontFamily: 'Source Sans Pro, sans-serif',
                fontSize: 16,
                padding: 15,
                marginTop: 5,
            },
            button: {
                cursor: 'pointer',
                backgroundColor: '#38B08C',
                borderRadius: 4,
                width: '100%',
                border: 'none',
                outline: 'none',
                appearance: 'none',
                fontFamily: 'Source Sans Pro, sans-serif',
                fontSize: 16,
                padding: 15,
                color: '#FFFFFF',
                marginTop: 20,
            },
            wrap: {
                padding: 20
            }
        };

        let loginType = (
            <form onSubmit={this.onFormSubmit.bind(this)}>
                <input style={style.input} type="text" placeholder="Email" value={this.state.email} onChange={this.onChange.bind(this)} name="email" />
                <input style={style.input} type="password" placeholder="Password" value={this.state.password} onChange={this.onChange.bind(this)} name="password" />
                <button style={style.button} type="submit" onClick={this.onSubmit.bind(this)}>Log in</button>
            </form>
        );

        let registerType = (
            <form onSubmit={this.onFormSubmit.bind(this)}>
                <input style={style.input} type="text" placeholder="Full name" value={this.state.fullName} onChange={this.onChange.bind(this)} name="fullName" />
                <input style={style.input} type="text" placeholder="Email" value={this.state.email} onChange={this.onChange.bind(this)} name="email" />
                <input style={style.input} type="password" placeholder="Password" value={this.state.password} onChange={this.onChange.bind(this)} name="password" />
                <button style={style.button} type="submit" onClick={this.onSubmit.bind(this)}>Register</button>
            </form>
        );

        let isLogin = this.state.type === 'login';

        if(!isLogin) {
            style.base.height += 55;
        }

        if(this.state.formFailed) {
            style.base.animation = 'shake 0.82s cubic-bezier(.36,.07,.19,.97) both';
        }

        return (
            <div style={style.base}>
                <div style={style.nav} className="cf">
                    <a style={isLogin ? style.navLinkActive : style.navLink} data-type="login" onClick={this.changeType.bind(this)}>Log in</a>
                    <a style={!isLogin ? style.navLinkActive : style.navLink} data-type="register" onClick={this.changeType.bind(this)}>Register</a>
                </div>
                <div style={style.wrap}>
                { isLogin ? loginType : registerType }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/WelcomeForm.js